import MediaPlanSelection from './MediaPlanSelection';

export default MediaPlanSelection;
